angular.module('picmonic-common').factory('StringUtils', function () {
  return {
    pluralize: function (noun, length = 0) {
      const suffix = ['s', 'sh', 'ch', 'x', 'z'].some(endPart => noun.endsWith(endPart)) ? 'es' : 's';

      return `${noun}${length !== 1 ? suffix : ''}`;
    },
  };
});
